import { render, staticRenderFns } from "./SysHealthPublicity.vue?vue&type=template&id=ebc60de6&"
import script from "./SysHealthPublicity.vue?vue&type=script&lang=js&"
export * from "./SysHealthPublicity.vue?vue&type=script&lang=js&"
import style0 from "./SysHealthPublicity.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports